import React from 'react'
import { useAppSelector } from 'reduxTyped'

import { BuilderIdContext } from 'common/builder/components/builder/BuilderIdProvider/BuilderIdProvider'
import { FieldsSelector, useFlowFields } from 'common/builder/hooks/useFlowFields'
import { makeIsPersonalizationDisabled } from 'common/builder/selectors/builder/builderStateSelectors'
import MCTextEditor, { IMCTextEditorLegacyProps } from 'components/MCTextEditor'
import { IMCTextEditorRef } from 'components/MCTextEditor/MCTextEditor'

import { NodeIdContext } from '../builder/NodeIdContext'

type FlowTextEditorProps = Omit<IMCTextEditorLegacyProps, 'getFields'> & {
  fieldsSelector?: FieldsSelector
}

const FlowTextEditor: React.ForwardRefRenderFunction<IMCTextEditorRef, FlowTextEditorProps> = (
  { fieldsSelector, withVariables, ...props },
  ref,
) => {
  const builderId = React.useContext(BuilderIdContext)?.builderId
  const nodeId = React.useContext(NodeIdContext)
  const isPersonalizationDisabled = useAppSelector(makeIsPersonalizationDisabled(builderId, nodeId))

  if (isPersonalizationDisabled) {
    withVariables = false
  }

  const fields = useFlowFields(fieldsSelector)

  return (
    <MCTextEditor ref={ref} {...props} withVariables={withVariables} getFields={() => fields} />
  )
}

export default React.forwardRef<IMCTextEditorRef, FlowTextEditorProps>(FlowTextEditor)
